import React from 'react';

import { Container } from '@mui/material';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { ComplianceTable } from './ComplianceTable/ComplianceTable';
import {
  CheckCircleLabel,
  PageTitle,
} from '../../../../../shared/components/ui-components';

const NgzComplianceBoardTab = () => {
  return (
    <Container>
      <PageTitle title="Today's Compliance Board">
        <CheckCircleLabel>Only active users</CheckCircleLabel>
      </PageTitle>
      <ComplianceTable />
    </Container>
  );
};

angularizeWithProviders(NgzComplianceBoardTab, 'ngzComplianceBoardTab', {});

export default NgzComplianceBoardTab;
